<template>
  <div class="p-4 bg-light position-relative border-start border-5 border-warning mb-2" style="position: relative">
    <div class="fs-16px mb-3 fw-bolder line-h-11 d-flex" style="position: relative;">{{ item.author.nickname |
      `${item.author.firstName} ${item.author.lastName}` }}
      <rating class="review-star " style="margin-left: 10px; position: relative" :rate="item.rate"></rating>
    </div>
    <div class="row">

      <div class="col-12">
        <div class="d-flex align-items-center">
          <div>
            <div class="fw-bold text-gray-600 fs-12px line-h-12" style="position: relative;"><span
                v-if="item.comment.length > 150">
                {{ showFullComment ? item.comment : truncatedComment }}
                <span @click="toggleFullComment" style="cursor: pointer; font-size: 10px;">
                  {{ showFullComment ? " ..Show less" : "..." }}
                </span>
              </span>
              <span v-else>
                {{ item.comment }}
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
import Rating from "@/components/Rating";

export default {
  name: "Review",
  props: ["item"],
  data() {
    return {
      showFullComment: false
    };
  },
  computed: {
    truncatedComment() {
      return this.item.comment.slice(0, 120);
    }
  },
  methods: {
    toggleFullComment() {
      this.showFullComment = !this.showFullComment;
    }
  },
  components: { rating: Rating }
}
</script>



// WEBPACK FOOTER //
// src/components/Review.vue